export enum WebPaymentTypeEnum {
  INVOICING = 'INVOICING',
  DEPOSIT = 'DEPOSIT',
  BILLING = 'BILLING',
  NO_PAYMENT = 'NO_PAYMENT',
}
